<div>
    <br />
    <div ng-form="userForm">
        <div class="row invoice-detail">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">
                        <app-page-title [title]="'Invoices'"></app-page-title>
                        <p>Click on an invoice number to download your invoice for the designated month.</p>

                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th
                                        class="text-center"
                                        width="120"
                                    >Date Issued</th>
                                    <th>Invoice Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    class="my-product-item-tr"
                                    *ngFor="let invoice of invoices"
                                >
                                    <td style="text-align: center; vertical-align: middle;">
                                        <div>{{invoice.dateIssued | date: "MMM d, yyyy 'at' h:mm a 'PST'"}}</div>
                                        <div *ngIf="invoice.dateIssued == null">Not Issued</div>
                                    </td>
                                    <td>
                                        <div class="row invoice-detail">
                                            <div>
                                                <p class="invoice-download-link">
                                                    <a
                                                        class="my-product-item-name-link"
                                                        (click)="downloadInvoice(invoice.id)"
                                                        target="_blank"
                                                    >
                                                        {{invoice.invoiceNumber}}
                                                    </a>
                                                </p>
                                                <small>
                                                    Order Total: {{invoice.totalAmount | currency:"CAD "}}<br />
                                                    Number of Orders: {{invoice.totalNumberOfOrders}}<br />
                                                </small>
                                                <div *ngIf="invoice.totalRefundAmount > 0"><small style="color:red;">Total Refund Amount: {{invoice.totalRefundAmount | currency:"CAD "}}</small></div>
                                                <small>
                                                    <a
                                                        id="invoice{{invoice.id}}"
                                                        class="my-product-item-name-link"
                                                        [routerLink]="['/account/user-orders-by-invoice', invoice.id]"
                                                    >View user orders</a>
                                                </small>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-modal
    #downloadModal
    title="Download is ready"
    body="Click here to download"
    isLinkDisplay="true"
    (clickLink)="generateInvoiceFile(pdfName)"
>
</app-modal>
